import React from 'react';
import Card from '../Card/Card';
import { FormattedMessage } from 'react-intl';
import PostbackLogs from './PostbackLogs';
import Pagination from '../Pagination/Pagination';
import { streams } from '../../services/ApiService';

export default class PostbackLogsTable extends React.Component {
  state = {
    loading: false,
    streamId: null,
    logs: [],
    count: 0,
    page: 0,
    limit: 25,
    error: '',
  };

  componentDidMount() {
    const { match } = this.props;

    if (match.params && match.params.id) {
      const streamId = parseInt(match.params.id, 10);

      if (!isNaN(streamId) && streamId > 0) {
        this.setState(
          () => ({
            loading: true,
            streamId,
          }),
          () => {
            const { limit, page } = this.state;
            this.getPostbackLogs(limit, page);
          },
        );
      } else if (match.params.id === 'logs') {
        this.setState(
          () => ({
            loading: true,
          }),
          () => {
            const { limit, page } = this.state;
            this.getGlobalPostbackLogs(limit, page);
          },
        );
      }
    }
  }

  /**
   * Get postback's logs by flow id
   *
   * @param {number} limit
   * @param {number} page
   * @return {Promise} Request result
   */
  getPostbackLogs = (limit, page) => {
    const { streamId } = this.state;

    return streams
      .getPostbackLogs(streamId, { limit, page })
      .then(({ items: logs, count }) => {
        this.setState(() => ({
          loading: false,
          logs,
          count,
        }));
      })
      .catch(({ response = {} }) => this.handleError(response));
  };

  /**
   * Get global postback's logs
   *
   * @param {number} limit
   * @param {number} page
   * @return {Promise} Request result
   */
  getGlobalPostbackLogs = (limit, page) =>
    streams
      .getGlobalPostbackLogs({ limit, page })
      .then(({ items: logs, count }) => {
        this.setState(() => ({
          loading: false,
          logs,
          count,
        }));
      })
      .catch(({ response = {} }) => this.handleError(response));

  handlePageChange = (page) => {
    this.setState(() => ({ loading: true }));
    const { streamId } = this.state;
    if (streamId) {
      this.getPostbackLogs(this.state.limit, page).then(() => this.setState({ page }));
    } else {
      this.getGlobalPostbackLogs(this.state.limit, page).then(() => this.setState({ page }));
    }
  };

  handleError = (response) => {
    if (response.data && response.data.error) {
      const { message: error } = response.data.error;

      this.setState(() => ({
        loading: false,
        error: error.message,
      }));
    }
  };

  render() {
    const { loading, limit, logs, count, page, error } = this.state;
    const pageCount = Math.ceil(count / limit);
    return (
      <Card loading={loading} className="postback-logs-card">
        <Card.Body>
          <div className="postback-logs-table-title">
            <FormattedMessage id="postback.logs.title" defaultMessage="Postback logs" />
          </div>
          <PostbackLogs logs={logs} error={error} />
        </Card.Body>

        {pageCount > 1 && (
          <Card.Footer>
            <Pagination
              activePage={page + 1}
              pageCount={pageCount}
              onPageChange={this.handlePageChange}
            />
          </Card.Footer>
        )}
      </Card>
    );
  }
}
